import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/tracker/$trackerId/results")({
    component: () => <div>Hello /tracker/$trackerId/results!</div>,
});
